import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/AttentionTable'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { attentionTable } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = attentionTable.name
  static widget = Widget
  static configure = createConfigure(attentionTable)
}
